<template>
	<div>
		<Card dis-hover>
			<Tabs value="name1" @on-click="changeTab">
				<TabPane label="硬件设置" name="name1"/>
				<TabPane label="软件设置" name="name2"/>
			</Tabs>
			<template v-if="defaultName=='name1'">
				<hardwareSetting ref="hardwareSetting"/>
			</template>
			<template v-if="defaultName=='name2'">
				<softwareSetting ref="softwareSetting" @changeUnitValue="changeUnitValue"/>
			</template>
		</Card>
		<weightReading ref="weightReading"/>
	</div>
</template>

<script>
	import hardwareSetting from "./components/hardwareSetting";
	import softwareSetting from "./components/softwareSetting";
	import weightReading from "_c/weightReading";

	export default {
		name: "setting",
		components: {hardwareSetting, softwareSetting, weightReading},
		data() {
			return {
				defaultName: "name1",
				defaultNames: ["name1"]
			};
		},
		methods: {
			changeTab(name) {
				if (!this.defaultNames.includes(name))
					this.defaultNames.push(name);

				this.defaultName = name;
				setTimeout(() => {
					if (name == "name1") {
						this.$refs.hardwareSetting.initPage();
					} else if (name == "name2") {
						this.$refs.softwareSetting.initPage();
					}
				}, 50);
			},
      //子组件传递来的事件
      changeUnitValue(data) {
        localStorage.setItem("unitValue", data)
        this.$refs.weightReading.showUnitValue();
        this.$refs.weightReading.openWeightDevice();
      }
		},
		mounted() {
			this.changeTab(this.defaultName);
		},
		activated() {
			this.changeTab(this.defaultName);
		},
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/system/setting.vue